import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import styles from '../styles'
import { messages } from './messages'

export function FreeShippingReview() {
  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.freeShipping}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
        }}
      />
    </SummaryRow.Value>
  )
}
